export default __webpack_public_path__ + "static/media/update.4584040e.svg";